import React from 'react';
import {
    Typography,
    Grid,
    Box,
    Card,
    CardContent,
    Button,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { closeButtonStyle, reweighButton } from '../MoveCylinders/utils';
import { trakrefFontFamily, isDesktop } from '../../../utils';
import { trakrefBlue, Grey2 } from '../../../color_utils';
import './index.css';

const CylinderCard = ({
    children,
}) => (
    <Box sx={{ minWidth: 275 }}>
        <Card variant="outlined" raised={false}>
            <CardContent sx={{ paddingTop: '1px' }}>
                <Grid container>
                    {children}
                </Grid>
            </CardContent>
        </Card>
    </Box>
);

const CylinderDetails = ({
    key_values,
    closeCylinderDetails,
    openReweighModal,
}) => (
    <CylinderCard>
        <IconButton sx={closeButtonStyle} onClick={closeCylinderDetails}>
            <CloseIcon />
        </IconButton>
        <Grid
            container
            direction="row"
            alignItems="center"
            columns={10}
            spacing={1}
        >
            {key_values.map((i, index) => (
                <Grid
                    item
                    xs={5}
                    md={2}
                    // lg={2}
                    sx={{
                        marginLeft: (index === 0 || index === 4) && isDesktop ? '1%' : '0%'
                    }}
                >
                    <Typography
                        variant="overline"
                        
                        style={{
                            color: trakrefBlue,
                            fontSize: '12px',
                            fontFamily: trakrefFontFamily,
                            fontWeight: 'bolder',
                            textTransform: 'uppercase',
                        }}
                    >
                        {i.title}
                    </Typography>
                    <Typography
                        variant="h4"
                        style={{
                            color: Grey2,
                            fontSize: '12px',
                            fontFamily: trakrefFontFamily
                        }}
                    >
                        {i.value}
                    </Typography>
                </Grid>
            ))}
            {isDesktop && (
                <Grid
                    container
                    item
                    xs={2}
                    md={2}
                    lg={2}
                    sx={{ marginLeft: 'auto', marginTop: '-4%' }}
                >
                    <Button
                        variant='outlined'
                        size='small'
                        sx={reweighButton}
                        onClick={openReweighModal}
                    >
                        Reweigh Cylinder
                    </Button>
                </Grid>
            )}
        </Grid>
    </CylinderCard>
);

export default CylinderDetails;
